import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { createFastDomNode } from '../../../../base/browser/fastDomNode.js';
import { ViewPart } from '../../view/viewPart.js';
export var Margin = /*#__PURE__*/function (_ViewPart) {
  _inherits(Margin, _ViewPart);

  var _super = _createSuper(Margin);

  function Margin(context) {
    var _this;

    _classCallCheck(this, Margin);

    _this = _super.call(this, context);
    var options = _this._context.configuration.options;
    var layoutInfo = options.get(117
    /* layoutInfo */
    );
    _this._canUseLayerHinting = !options.get(23
    /* disableLayerHinting */
    );
    _this._contentLeft = layoutInfo.contentLeft;
    _this._glyphMarginLeft = layoutInfo.glyphMarginLeft;
    _this._glyphMarginWidth = layoutInfo.glyphMarginWidth;
    _this._domNode = createFastDomNode(document.createElement('div'));

    _this._domNode.setClassName(Margin.OUTER_CLASS_NAME);

    _this._domNode.setPosition('absolute');

    _this._domNode.setAttribute('role', 'presentation');

    _this._domNode.setAttribute('aria-hidden', 'true');

    _this._glyphMarginBackgroundDomNode = createFastDomNode(document.createElement('div'));

    _this._glyphMarginBackgroundDomNode.setClassName(Margin.CLASS_NAME);

    _this._domNode.appendChild(_this._glyphMarginBackgroundDomNode);

    return _this;
  }

  _createClass(Margin, [{
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Margin.prototype), "dispose", this).call(this);
    }
  }, {
    key: "getDomNode",
    value: function getDomNode() {
      return this._domNode;
    } // --- begin event handlers

  }, {
    key: "onConfigurationChanged",
    value: function onConfigurationChanged(e) {
      var options = this._context.configuration.options;
      var layoutInfo = options.get(117
      /* layoutInfo */
      );
      this._canUseLayerHinting = !options.get(23
      /* disableLayerHinting */
      );
      this._contentLeft = layoutInfo.contentLeft;
      this._glyphMarginLeft = layoutInfo.glyphMarginLeft;
      this._glyphMarginWidth = layoutInfo.glyphMarginWidth;
      return true;
    }
  }, {
    key: "onScrollChanged",
    value: function onScrollChanged(e) {
      return _get(_getPrototypeOf(Margin.prototype), "onScrollChanged", this).call(this, e) || e.scrollTopChanged;
    } // --- end event handlers

  }, {
    key: "prepareRender",
    value: function prepareRender(ctx) {// Nothing to read
    }
  }, {
    key: "render",
    value: function render(ctx) {
      this._domNode.setLayerHinting(this._canUseLayerHinting);

      this._domNode.setContain('strict');

      var adjustedScrollTop = ctx.scrollTop - ctx.bigNumbersDelta;

      this._domNode.setTop(-adjustedScrollTop);

      var height = Math.min(ctx.scrollHeight, 1000000);

      this._domNode.setHeight(height);

      this._domNode.setWidth(this._contentLeft);

      this._glyphMarginBackgroundDomNode.setLeft(this._glyphMarginLeft);

      this._glyphMarginBackgroundDomNode.setWidth(this._glyphMarginWidth);

      this._glyphMarginBackgroundDomNode.setHeight(height);
    }
  }]);

  return Margin;
}(ViewPart);
Margin.CLASS_NAME = 'glyph-margin';
Margin.OUTER_CLASS_NAME = 'margin';